import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Popover, Tag, Typography } from 'antd'

import { IReview } from '../../../../context/types'

const { Paragraph, Text } = Typography

export const columns = (onModerate: (id: number) => void) => [
	{
		title: 'Expert',
		render: (_: any, v: IReview) => (
			<Paragraph ellipsis style={{ maxWidth: 200, margin: 0, opacity: v.moderatedBy ? 0.5 : 1 }}>
				<Link
					to={`/expert/${v.user.expertProfiles[0]?.pages[0]?.slug}`}
					target="_blank"
				>{`${v.user.first_name} ${v.user.last_name}`}</Link>
			</Paragraph>
		),
	},
	{
		title: 'User',
		render: (_: any, v: IReview) => (
			<Paragraph ellipsis style={{ maxWidth: 200, margin: 0, opacity: v.moderatedBy ? 0.5 : 1 }}>
				<a
					href={`mailto:${v.leftBy.email}`}
					target="_blank"
					rel="noreferrer"
				>{`${v.leftBy.first_name} ${v.leftBy.last_name}`}</a>
			</Paragraph>
		),
	},
	{
		title: 'Date',
		dataIndex: 'left_on',
		key: 'left_on',
		sorter: () => 0,
		render: (left_on: string, v: IReview) => (
			<Text style={{ opacity: v.moderatedBy ? 0.5 : 1 }}>{new Date(left_on).toLocaleString()}</Text>
		),
	},
	{
		title: 'Rating',
		dataIndex: 'rating',
		key: 'rating',
		sorter: () => 0,
		render: (rating: number, v: IReview) => (
			<Tag color={rating > 4 ? 'geekblue' : 'volcano'} style={{ opacity: v.moderatedBy ? 0.5 : 1 }}>
				{rating}
			</Tag>
		),
	},
	{
		title: 'Review text',
		dataIndex: 'body',
		render: (body: string, v: IReview) => (
			<Popover content={() => <div style={{ maxWidth: 400 }}>{body}</div>}>
				<Paragraph ellipsis style={{ maxWidth: 100, margin: 0, opacity: v.moderatedBy ? 0.5 : 1 }}>
					{body}
				</Paragraph>
			</Popover>
		),
	},
	{
		title: 'Response text',
		dataIndex: 'responce',
		key: 'responce',
		sorter: () => 0,
		render: (responce: string, v: IReview) => (
			<Popover content={() => <div style={{ maxWidth: 400 }}>{responce}</div>}>
				<Paragraph ellipsis style={{ maxWidth: 100, margin: 0, opacity: v.moderatedBy ? 0.5 : 1 }}>
					{responce}
				</Paragraph>
			</Popover>
		),
	},
	{
		title: '',
		render: (_: any, v: IReview) => (
			<Button type="link" disabled={!!v.moderatedBy} onClick={() => onModerate(v.id)}>
				Remove
			</Button>
		),
	},
]
